import { render } from "./DetailDistanceCalculatorEvent.vue?vue&type=template&id=2ed16aae&scoped=true"
import script from "./DetailDistanceCalculatorEvent.vue?vue&type=script&lang=js"
export * from "./DetailDistanceCalculatorEvent.vue?vue&type=script&lang=js"

import "./DetailDistanceCalculatorEvent.vue?vue&type=style&index=0&id=2ed16aae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed16aae"]])

export default __exports__